import React, {useState} from 'react';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Button, Divider, Layout, Text, Card, Icon } from '@ui-kitten/components';
import { StyleSheet , TouchableOpacity, Linking } from 'react-native';
import * as RootNavigation from '../../../root.navigation.js';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { showMessage, hideMessage } from "react-native-flash-message";
import trackerApi from '../../api/tracker';

const ExitIcon = (props) => (
  <Icon {...props}
    style={[props.style, {width:24,height:24 , marginRight:6, marginLeft:6}]}
    fill = '#8F9BB3'
    name='log-out'/>
);
const SupportIcon = (props) => (
  <Icon {...props}
    style={[props.style, {width:24,height:24 , marginRight:6, marginLeft:6}]}
    fill = '#8F9BB3'
    name='phone-call'/>
);
const GIcon = (props) => (
  <Icon {...props}
    style={[props.style, {width:24,height:24 , marginRight:6, marginLeft:6}]}
    fill = '#8F9BB3'
    name='bulb'/>
);
const RuleIcon = (props) => (
  <Icon {...props}
    style={[props.style, {width:24,height:24 , marginRight:6, marginLeft:6}]}
    fill = '#8F9BB3'
    name='info'/>
);

const FaqIcon = (props) => (
  <Icon {...props}
    style={[props.style, {width:24,height:24 , marginRight:6, marginLeft:6}]}
    fill = '#8F9BB3'
    name='question-mark-circle'/>
);
const TextIcon = (props) => (
  <Icon {...props}
    style={[props.style, {width:24,height:24 , marginRight:6, marginLeft:6}]}
    fill = '#8F9BB3'
    name='file-text'/>
);

export const Action = ({ navigation }) => {
  const navigateDetails = () => {
    navigation.navigate('Details');
  };
  const logout = async()=>{
    await AsyncStorage.removeItem('userId');
    RootNavigation.navigate('Login')
  }

  const downloadContract = async() => {
    const token =  await AsyncStorage.getItem('userId');
    const response = await trackerApi.post('/app/contract', null,
    {
      headers: {Authorization: `Bearer ${token}`}
    });
    if(response.data.status){
      console.log(response.data.contract);
      Linking.openURL(response.data.contract).catch((err) => console.error('An error occurred', err));

    } else showMessage({
        message: `قراردادی برای نمایش وجود ندارد.`,
        type: "warning",
      });
  }

  return (
    <Layout
    style={styles.item}
    >
      <TouchableOpacity onPress={()=>{RootNavigation.navigate('Sharayet')}}>
      <Layout style={styles.contentContainer}>
        <RuleIcon />
        <Text style={styles.text}>شرایط و مقررات</Text>
      </Layout>
      </TouchableOpacity>
      <Divider />

      <TouchableOpacity onPress={()=>{RootNavigation.navigate('Faq')}}>
      <Layout style={styles.contentContainer}>
        <FaqIcon />
        <Text style={styles.text}>سوالات پر تکرار</Text>
      </Layout>
      </TouchableOpacity>
      <Divider />
      {/*
      <TouchableOpacity >
      <Layout style={styles.contentContainer}>
        <GIcon />
        <Text style={styles.text}>خدمات شامل گارانتی</Text>
      </Layout>
      </TouchableOpacity>
      <Divider />
*/}
      <TouchableOpacity onPress={downloadContract}>
      <Layout style={styles.contentContainer}>
        <TextIcon />
        <Text style={styles.text}>قرارداد با شرکت</Text>
      </Layout>
      </TouchableOpacity>
      <Divider />

      <TouchableOpacity onPress={()=>{Linking.openURL(`tel:09126384420`)}} >
      <Layout style={styles.contentContainer}>
        <SupportIcon />
        <Text style={styles.text}>تماس با پشتیبانی</Text>
      </Layout>
      </TouchableOpacity>
      <Divider />
      <TouchableOpacity onPress={ logout } >
      <Layout style={styles.contentContainer}>
        <ExitIcon />
        <Text style={styles.text}>خروج از حساب کاربری</Text>
      </Layout>
      </TouchableOpacity>
    </Layout>
  );
};


const styles = StyleSheet.create({

  contentContainer: {
  flexDirection:'row' ,
  alignItems:'center',
  paddingVertical:12,

  },
  item: {
    marginTop: 10,
    paddingHorizontal:6

  },
  text:{
    marginHorizontal:10
  }
});
